import React from 'react';
import { callAll } from 'Utils';
import { Modal } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './FactoryModals.css';

type Props = {
    modals: ModalProp[];
    defaultOnClose: (id: string | number) => void;
};

function FactoryModals({ modals, defaultOnClose }: Props) {
    const { t } = useTranslation();
    return (
        <div data-testid='modal-factory'>
            {modals.map((modal: ModalProp) => {
                const {
                    id,
                    status,
                    content,
                    title,
                    cancelText,
                    onAction,
                    onActionText,
                    titleChildren,
                    showCloseIcon,
                    showCloseButton,
                    closeOnAction
                } = modal;
                const onClose = callAll(defaultOnClose, modal?.onClose);
                const isErrorStatus = status === 'error';
                const closeText = cancelText || t('Cancel');
                const closeIcon = showCloseIcon ?? true;
                const closeButton = showCloseButton ?? true;
                const closeAction = closeOnAction ?? false;

                return (
                    <Modal
                        key={id}
                        isOpen
                        dataTestId={`${id}-modal`}
                        closeModal={() => onClose(id)}
                        status={status}
                        closeOnClickOutside={false}
                        containerClass={styles.factoryModal}
                    >
                        <Modal.Title
                            id={`${id}-modal-title`}
                            title={title ?? ''}
                            onClose={() => onClose(id)}
                            showCloseIcon={closeIcon}
                            statusIcon={status}
                        >
                            <>{titleChildren}</>
                        </Modal.Title>
                        <div className={clsx(styles.content, isErrorStatus && styles.error)}>{content}</div>
                        {/*
                            Assuming there is no onAction callback as these
                            modal factories are more for informational
                        */}
                        <Modal.Footer
                            id={`${id}-modal-footer`}
                            onCloseText={closeButton ? closeText : ''}
                            onClose={() => onClose(id)}
                            onAction={closeAction ? () => onClose(id) : onAction}
                            onActionText={onActionText}
                        />
                    </Modal>
                );
            })}
        </div>
    );
}

export default FactoryModals;
